export { Moon2 as default } from './Moon2';
